import React, { useState, useEffect } from "react";
import { Route , Switch } from "react-router-dom";
import { Toaster , toast } from "react-hot-toast"
// import Import from "./components/connectors/steps/import" ;
import ProtectedRoute from "./components/common/protectedRoute";
import './App.css';

import MainView from "./components/staffing/main"; 
import logger from "./services/logger";
import ReactGA from "react-ga4" ;
import NotFoundPage from "./components/common/notfound";
import { Helmet } from "react-helmet";
import OfficerBulk from "./components/staffing/agency/orm/import/main" ; 

// staffing 

import StaffAllocationCompanyNew from "./components/staffing/agency/staffAllocationCompanyNew" ; 
// import Assign from "./components/staffing/agency/jobs" ; 
import Assign from "./components/staffing/agency/jobs/dashboard/job" ; 
// import Integrations from "./components/staffing/agency/jobs/intergations" ; 
// import Statistics from "./components/staffing/agency/jobs/statistics" ; 
import OfficerRecommendations from "./components/staffing/agency/jobs/offers/recommendations/listing" ; 
// import StaffDetail from "./components/staffing/agency/jobs/offers/recommendations/listingdetail/listingdetailpage" ; 
// import StaffDatabase from "./components/staffing/agency/jobs/staff-database/database" ;
import ProviderStaffAllocationCompanyOnboarding from "./components/staffing/agency/onboarding" ;
// import NewWorkOrderOld from "./components/staffing/agency/jobs/PreferenceCards/NewOrder" ; // delete later
import NewWorkOrder from "./components/staffing/agency/crm/jobform/create" ;
import NewCustomer from "./components/staffing/agency/crm/customerform" ;
import Customers from "./components/staffing/agency/crm/customer" ;
import CustomerList from "./components/staffing/agency/crm/CustomerList" ;
import CustomerDetail from "./components/staffing/agency/crm/CustomerDetail" ;
import OfferStatus from "./components/staffing/agency/jobs/offers/status/statusStandalone" ;
import Offer from "./components/staffing/agency/jobs/offers/offer" ;
import JobDetail from "./components/staffing/agency/jobs/jobDetail/JobDetail" ;
import DispatchPage from "./components/staffing/agency/dispatch/DispatchPage" ;
import JobDispatchDetail from "./components/staffing/agency/dispatch/jobsTab/job-detail/JobDispatchDetail" ;
import ShiftDetailMaster from './components/staffing/agency/dispatch/scheduleTab/shift-detail/ShiftDetailMaster';
import CreateJobDispatchPage from "./components/staffing/agency/dispatch/create-job/CreateJobDispatchPage" ;
import AgencyHome from "./components/staffing/agency/home/AgencyHome" ;
import Settings from "./components/staffing/agency/settings/setting" ;

import StaffAllocationAccount from "./components/staffing/agency/account/account" ;
// import Signal from "./components/staffing/agency/signals/signal" ;
import Team from "./components/staffing/agency/team/team"
import Officer from "./components/staffing/agency/orm/officer"
import OfficerList from "./components/staffing/agency/orm/OfficerList"
import OfficerDetail from "./components/staffing/agency/orm/OfficerDetail"


import WorkOrder from "./components/staffing/officer/dashboard/workOrder"
import WorkOrderAccepted from "./components/staffing/officer/dashboard/workOrderAccepted"
import WorkOrderCompleted from "./components/staffing/officer/dashboard/workOrderCompleted"
import Agenda from "./components/staffing/officer/dashboard/agenda" ;
import ProviderResourceAccount from "./components/staffing/officer/account/account" ; 
import Performance from "./components/staffing/officer/dashboard/performance" ;
import { getUserInfo } from  "./services/userService" ; 
import ResourceForm from "./components/staffing/officer/dashboard/resourceForm" ;
import MobileAppPrompt from "./components/staffing/officer/MobileAppPrompt" ;

import PartnerSuccess from "./components/staffing/agency/partnerSuccess" ;


import CustomerCompanyTeam from "./components/staffing/customer/team/team" ;
import CustomerCompanyAccount from "./components/staffing/customer/account/account" ;
import CustomerCompanyJobs from "./components/staffing/customer/jobs/dashboard/job" ;
import CustomerCompanyFacilities from "./components/staffing/customer/facilities/facilities" ;
import FacilityDetail from "./components/staffing/customer/facilities/facilityDetails/FacilityDetail" ;
// customer company components 
import CustomerDashboard from "./components/staffing/customer/dashboard/CustomerDashboard" ;
import CustomerJobDetail from "./components/staffing/customer/jobs/jobDetails/CustomerJobDetail" ;
import LandingPage from "./components/landing/page" ;
import Activate from "./components/activate/Activate" ;


const App = () => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    ReactGA.initialize('G-3KC33TK96R');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []); 

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRON === "production") {
      logger.init();
    }
  }, []);


  return (
    <>
        <Toaster position="top-center"  reverseOrder={false} /> 
        <Switch>
  
          {/* === Agency / Dispatch Manager ======== */}
          <ProtectedRoute path="/provider-company/:providerCompanyId/dashboard" component={AgencyHome} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/dispatch/job/new" component={CreateJobDispatchPage} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/dispatch/shift/:shiftId" component={ShiftDetailMaster} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/dispatch/job/:jobId" component={JobDispatchDetail} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/dispatch" component={DispatchPage} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/jobs/:jobId/offer/:offerId" component={OfferStatus} />  
          <ProtectedRoute path="/provider-company/:providerCompanyId/jobs/:jobId/offer" component={Offer} />  
          <ProtectedRoute path="/provider-company/:providerCompanyId/jobs/:jobId" component={JobDetail} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/jobs" component={Assign} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/dashboard/account" component={StaffAllocationAccount} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/team" component={Team} />
          {/* http://localhost:3000/provider-company/6728eabf3ee6a31c5c841d93/orm/import*/}
          <ProtectedRoute path="/provider-company/:providerCompanyId/orm/import" component={OfficerBulk} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/orm/:officerId" component={OfficerDetail} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/orm" component={OfficerList} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/settings" component={Settings} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/onboarding" component={ProviderStaffAllocationCompanyOnboarding} />
          {/* <ProtectedRoute path="/provider-company/new" component={StaffAllocationCompanyNew} /> */}
          <ProtectedRoute path="/provider-company/:providerCompanyId/crm/:customerCompanyLocalId/job/new" component={NewWorkOrder} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/crm/new" component={NewCustomer} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/crm/:customerCompanyLocalId" component={CustomerDetail} />
          <ProtectedRoute path="/provider-company/:providerCompanyId/crm" component={CustomerList} />
          {/* <ProtectedRoute path="/provider-company/:providerCompanyId/signal" component={Signal} /> */}
          <ProtectedRoute path="/provider-company/:providerCompanyId" component={AgencyHome} />
          
          {/* <ProtectedRoute path="/staffing/partner-registration" component={PartnerRegistration} />  */}

          {/* ====== Officer =============  */}
          <ProtectedRoute path="/provider-resource/:providerCompanyId/mobile" component={MobileAppPrompt} />
          <ProtectedRoute path="/provider-resource/:providerCompanyId/dashboard/work-order/open" component={WorkOrder} />
          <ProtectedRoute path="/provider-resource/:providerCompanyId/dashboard/work-order/accepted" component={WorkOrderAccepted} />
          <ProtectedRoute path="/provider-resource/:providerCompanyId/dashboard/work-order/completed" component={WorkOrderCompleted} />
          <ProtectedRoute path="/provider-resource/:providerCompanyId/dashboard/account" component={ProviderResourceAccount} />
          <ProtectedRoute path="/provider-resource/:providerCompanyId/dashboard/performance" component={Performance} />   
          <ProtectedRoute path="/provider-resource/:providerCompanyId/resource/details/add" component={ResourceForm} />

          {/* ======= Customer ============ */}
          <ProtectedRoute path="/customer-company/:customerCompanyId/team" component={CustomerCompanyTeam} />
          <ProtectedRoute path="/customer-company/:customerCompanyId/account" component={CustomerCompanyAccount} />
          <ProtectedRoute path="/customer-company/:customerCompanyId/dashboard/jobs" component={CustomerCompanyJobs} />
          {/* Split-pane job detail — non-exact, catches /shift/:shiftId suffix without re-mounting */}
          <ProtectedRoute path="/customer-company/:customerCompanyId/jobs/:jobId" component={CustomerJobDetail} />
          {/* Work Orders list — must be after /jobs/:jobId */}
          <ProtectedRoute path="/customer-company/:customerCompanyId/jobs" component={CustomerCompanyJobs} />
          <ProtectedRoute path="/customer-company/:customerCompanyId/work-order/open" component={CustomerCompanyJobs} />
          <ProtectedRoute path="/customer-company/:customerCompanyId/facilities/:facilityId/job/new" component={CustomerJobDetail} />
          {/* Facility detail — must be before /facilities */}
          <ProtectedRoute path="/customer-company/:customerCompanyId/facilities/:facilityId" component={FacilityDetail} />
          <ProtectedRoute path="/customer-company/:customerCompanyId/facilities" component={CustomerCompanyFacilities} />
          {/* <ProtectedRoute path="/customer-company/:customerCompanyId/" component={CustomerCompanyMain} /> */}
          <ProtectedRoute path="/customer-company/:customerCompanyId/" component={CustomerDashboard} />

 
          {/* =========== common =========== */}
          <ProtectedRoute path="/partner-success" component={PartnerSuccess} /> 
          <ProtectedRoute path="/home" component={MainView} />
          {/* Magic-link activation — no auth required */}
          <Route path="/activate" component={Activate} />
          <Route path="/404" component={NotFoundPage} />
          {/* <Route path="/new" component={Home} /> */}
          <Route path="/" component={LandingPage} />

        </Switch>


    </>
  );
}

export default App;